(function () {
  "use strict";

  angular
    .module("app")
    .directive("routeSyncSummary", routeSyncSummary);

  routeSyncSummary.$inject = [];

  function routeSyncSummary() {
    // Usage: Display origin-destination info, route stats, and vehicle summary info
    //
    var directive = {
      bindToController: true,
      controller: routeSyncSummaryController,
      controllerAs: "vm",
      link: link,
      restrict: "E",
      templateUrl: "/app/route-sync/route-sync-summary/routeSyncSummary.template.html"
    };
    return directive;

    function link(scope, element, attrs) {}
  }

  /* @ngInject */
  function routeSyncSummaryController($filter, routeService) {
    let vm = this;

    vm.routeODInfo = routeODInfo;
    vm.routeStats = routeStats;
    vm.getCurrentRoute = getCurrentRoute;

    function routeODInfo() {
      var route = routeService.getSelectedRoute();
      var infoStr = "";
      var numStops = route.stops.length;
      if (numStops === 0)
        return;
      infoStr += route.stops[0].CityStateZip;
      infoStr += " to " + route.stops[numStops - 1].CityStateZip;
      infoStr += " : " + ((numStops === 2) ? "No " : numStops - 2) + " Stop" + ((numStops === 3) ? "" : "s");
      return infoStr;
    }

    function routeStats() {
      var route = routeService.getSelectedRoute();
      var statStr = distanceUnit() + ": " + $filter("number")(route.routeTMiles, 1) + " | Time: " + route.routeTHours + " | Cost: $" + $filter("number")(route.routeTCost, 2);
      return statStr;
    }

    function distanceUnit() {
      var route = routeService.getSelectedRoute();
      return (route.options.distanceUnits === 0) ? "Miles" : "KMs";
    }

    function getCurrentRoute() {
      return routeService.getSelectedRoute();
    }
  }
})();



// WEBPACK FOOTER //
// ./app/route-sync/route-sync-summary/routeSyncSummary.directive.js